var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashbaord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0064,0) scale(12.8,12.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.708,6.667h-6.25c-0.38686,0 -0.75786,-0.15375 -1.03132,-0.42739c-0.27346,-0.27364 -0.42695,-0.64475 -0.42668,-1.03161v-3.75c0,-0.80523 0.65277,-1.458 1.458,-1.458h6.25c0.38686,-0.00027 0.75796,0.15323 1.03161,0.42668c0.27364,0.27346 0.42739,0.64446 0.42739,1.03132v3.75c0.00027,0.38703 -0.15336,0.75829 -0.42704,1.03196c-0.27367,0.27367 -0.64493,0.4273 -1.03196,0.42704zM1.458,1.25c-0.11488,0 -0.208,0.09312 -0.208,0.208v3.75c0,0.11488 0.09312,0.208 0.208,0.208h6.25c0.11488,0 0.208,-0.09312 0.208,-0.208v-3.75c0,-0.11488 -0.09312,-0.208 -0.208,-0.208z",
    id: "Path_1"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,-1.667)",
    d: "M7.708,21.667h-6.25c-0.38686,0 -0.75786,-0.15375 -1.03132,-0.42739c-0.27346,-0.27364 -0.42695,-0.64475 -0.42668,-1.03161v-8.75c0,-0.80523 0.65277,-1.458 1.458,-1.458h6.25c0.80523,0 1.458,0.65277 1.458,1.458v8.75c0,0.80523 -0.65277,1.458 -1.458,1.458zM1.458,11.25c-0.11488,0 -0.208,0.09312 -0.208,0.208v8.75c0,0.11488 0.09312,0.208 0.208,0.208h6.25c0.11488,0 0.208,-0.09312 0.208,-0.208v-8.75c0,-0.11488 -0.09312,-0.208 -0.208,-0.208z",
    id: "Path_2"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-2.167,-2.667)",
    d: "M20.708,22.667h-6.25c-0.38686,0 -0.75786,-0.15375 -1.03132,-0.42739c-0.27346,-0.27364 -0.42695,-0.64475 -0.42668,-1.03161v-3.75c0,-0.80523 0.65277,-1.458 1.458,-1.458h6.25c0.80523,0 1.458,0.65277 1.458,1.458v3.75c0,0.80523 -0.65277,1.458 -1.458,1.458zM14.458,17.25c-0.11488,0 -0.208,0.09312 -0.208,0.208v3.75c0,0.11488 0.09312,0.208 0.208,0.208h6.25c0.11488,0 0.208,-0.09312 0.208,-0.208v-3.75c0,-0.11488 -0.09312,-0.208 -0.208,-0.208z",
    id: "Path_3"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-2.167,0)",
    d: "M20.708,11.667h-6.25c-0.38686,0 -0.75786,-0.15375 -1.03132,-0.42739c-0.27346,-0.27364 -0.42695,-0.64475 -0.42668,-1.03161v-8.75c0,-0.80523 0.65277,-1.458 1.458,-1.458h6.25c0.80523,0 1.458,0.65277 1.458,1.458v8.75c0,0.80523 -0.65277,1.458 -1.458,1.458zM14.458,1.25c-0.11488,0 -0.208,0.09312 -0.208,0.208v8.75c0,0.11488 0.09312,0.208 0.208,0.208h6.25c0.11488,0 0.208,-0.09312 0.208,-0.208v-8.75c0,-0.11488 -0.09312,-0.208 -0.208,-0.208z",
    id: "Path_4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashbaord);
export default __webpack_public_path__ + "static/media/dashbaord.45e75cb64d7922106185eb8d5d0d5417.svg";
export { ForwardRef as ReactComponent };